import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'getTimeInMinutes',
})
export class GetTimeInMinutesPipe implements PipeTransform {
  transform(date: string, format: string = 'MM-DD-YYYY HH:mm'): any {
    if (!date) return 0;

    const d = moment(date, format);

    return d.hour() * 60 + d.minute();
  }
}
